import React, { useEffect, useRef, useState } from "react";
import Map from "../../../components/map/Map";
import { Service, WeatherStationStates } from "@helpers/ui_helper";
import { Button, Form, Input, Select, Tour } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createWeatherStation,
  getStaticCities,
  getStaticProvinces,
  updateWeatherStation,
} from "../../../services/api";
import crossWhite from "../../../public/assets/icons/cross-white.svg";
import tikwhite from "../../../public/assets/icons/Tik-white.svg";
import { weatherStationFormSteps } from "../../../tour_steps/weatherStations";
import { QuestionCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { CustomMarker } from "../../../components/map/utils/customs";
import { toolbarBaseControls } from "../../../features/map/utils/configs";
import AgroMapPoint from "../../../features/map/presentation/components/AgroMapPoint";

function MapPoint({ service, setWeatherStationState, defaultData }) {
  const [provinces, setProvinces] = useState([]);
  const [isProvience, setIsProvience] = useState(9999999);
  const [isCity, setIsCity] = useState(8888888);
  const [cities, setCities] = useState([]);
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();
  const ref1 = useRef(null);
  const ref2 = useRef(null);

  const [stationObject, setStationObject] = useState({
    name: defaultData?.name ?? "",
    location: defaultData?.location ?? null,
    provinceId: defaultData?.provinceId ?? null,
    cityId: defaultData?.cityId ?? null,
    zone: defaultData?.zone ?? "",
  });

  const staticProvincesQuery = useQuery(
    ["staticsProvinces"],
    getStaticProvinces
  );

  const staticCitiesQuery = useQuery(["staticCities"], getStaticCities);

  const createStationMutation = useMutation(createWeatherStation, {
    onSuccess: () => {
      setWeatherStationState({
        service: Service.Weather,
        state: WeatherStationStates.AddStationIntro,
        stationObject: null,
      });
      queryClient.invalidateQueries(["weatherStations"]);
    },
  });

  const updateStationMutation = useMutation(updateWeatherStation, {
    onSuccess: () => {
      setWeatherStationState({
        service: Service.Weather,
        state: WeatherStationStates.AddStationIntro,
        stationObject: null,
      });
      queryClient.invalidateQueries(["weatherStations"]);
    },
  });

  useEffect(() => {
    if (staticProvincesQuery?.data) {
      let provs = staticProvincesQuery?.data?.map((province) => {
        return { label: province.name, value: province.id };
      });
      setProvinces(provs);
    }
  }, [staticProvincesQuery?.data]);

  useEffect(() => {
    if (stationObject?.provinceId) {
      let cities = staticCitiesQuery?.data
        ?.filter((city) => city.provinceId === stationObject?.provinceId)
        .map((c) => {
          return { label: c.name, value: c.id };
        });
      setCities(cities);
      // setStationObject(prev=> ({...prev, cityId: null}))
    }
  }, [
    stationObject?.provinceId,
    staticProvincesQuery?.data,
    staticCitiesQuery?.data,
  ]);

  const submitStation = () => {
    if (defaultData) {
      updateStationMutation.mutate({
        data: stationObject,
        weatherStationId: defaultData?.id,
      });
    } else {
      if (isProvience === 9999999) {
        setIsProvience(0);
      }
      if (isCity === 8888888) {
        setIsCity(0);
      }
      document.querySelector(".Frame1966").focus();
      createStationMutation.mutate(stationObject);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex animate-pulse p-3 bg-[#FBF199] justify-center items-center gap-1  rounded-xl w-[80%] m-auto">
        <WarningOutlined className="text-red-600 text-lg" />
        <div className="text-right text-[#111111] max-lg:text-xs">
          موقعیت ایستگاه هواشناسی خود را روی نقشه انتخاب کنید
        </div>
      </div>

      <div className="Default relative box-shadow agrobg flex flex-col w-fit pb-4 font-body rounded-2xl justify-center items-center gap-4">
        <div className="Earth p-2 agrobg rounded-2xl justify-center items-center gap-4 flex max-lg:flex-col">
          <div className="Borderin self-stretch agrobg rounded-lg inner-box-shadow border max-lg:flex-col justify-center items-center gap-4 flex overflow-hidden">
            <div className="Map  w-full h-full rounded-tl-2xl rounded-tr-2xl rounded-bl-lg rounded-br-lg flex-col justify-center items-center gap-2.5 flex">
              <div
                ref={ref1}
                className="lg:w-[50vw] max-lg:w-[90vw] h-[42vh] max-lg:flex-col "
              >
                <AgroMapPoint
                  type="add"
                  mapId="556895"
                  markerIcon={CustomMarker}
                  toolbarOptions={toolbarBaseControls}
                  currentPoint={defaultData?.location}
                  farmerFarms={[]}
                  onConfirm={(point) =>
                    setStationObject((prev) => ({
                      ...prev,
                      location: point,
                    }))
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <Form autoComplete="nope">
          <div
            ref={ref2}
            className="Inputs flex max-lg:flex-col flex-wrap w-[650px] max-lg:w-full max-lg:gap-y-2 !font-body justify-between items-start max-lg:items-center"
          >
            <div className="Name flex w-[300px] h-[80px] flex-col justify-start items-start gap-2">
              <div className=" text-right text-zinc-700 text-sm font-medium">
                <span className="text-[#ff4d4f]">* </span>
                نام ایستگاه هواشناسی
              </div>

              <Form.Item
                className="w-full"
                name="stationName"
                rules={[
                  { required: true, message: "نام ایستگاه خود را وارد کنید" },
                ]}
              >
                <Input
                  autoComplete="nope"
                  disabled={!stationObject?.location}
                  placeholder="نام دلخواه خود را وارد کنید"
                  className="Frame1966 self-stretch pl-24 pr-4 py-2 input-neo rounded-3xl justify-end items-center gap-2.5 flex"
                  onChange={(e) =>
                    setStationObject({
                      ...stationObject,
                      name: e?.target?.value,
                    })
                  }
                  defaultValue={stationObject?.name}
                />
              </Form.Item>
            </div>

            <div className="Prividence flex w-[300px] h-[80px] flex-col justify-start items-start gap-2">
              <div className=" text-right text-zinc-700 text-sm font-medium">
                <span className="text-[#ff4d4f]">* </span>
                استان
              </div>

              <Select
                autoComplete="nope"
                showSearch
                optionFilterProp="label"
                disabled={!stationObject?.location}
                className="provinces button-neo self-stretch px-4 py-1 rounded-3xl justify-between items-center flex"
                options={provinces}
                onChange={(value) => {
                  setIsProvience(value);
                  setStationObject({
                    ...stationObject,
                    provinceId: value,
                    cityId: null,
                  });
                }}
                placeholder="--انتخاب استان--"
                value={stationObject?.provinceId}
              />

              <p
                className={`text-right pr-[5px] text-[#ff4d4f] ${
                  !isProvience ? "block" : "hidden"
                }`}
              >
                استان خود را انتخاب کنید
              </p>
            </div>

            <div className="City flex w-[300px] h-[80px] flex-col justify-start items-start gap-2">
              <div className=" w-20 text-right text-zinc-700 text-sm font-medium">
                <span className="text-[#ff4d4f]">* </span>
                شهر
              </div>

              <Select
                autoComplete="nope"
                showSearch
                optionFilterProp="label"
                disabled={!stationObject?.location}
                className="city button-neo self-stretch px-4 py-1 rounded-3xl justify-between items-center flex"
                options={cities}
                onChange={(value) => {
                  setIsCity(value);
                  setStationObject({ ...stationObject, cityId: value });
                }}
                placeholder="--انتخاب شهر--"
                value={stationObject?.cityId}
              />
              <p
                className={`text-right pr-[5px] text-[#ff4d4f] ${
                  !isCity ? "block" : "hidden"
                }`}
              >
                شهر خود را انتخاب کنید
              </p>
            </div>

            <div className="Zone flex w-[300px] h-[80px] flex-col justify-start items-start gap-2">
              <div className=" w-20 text-right text-zinc-700 text-sm font-medium">
                منطقه
              </div>
              <Form.Item className="w-full" name="zone">
                <Input
                  autoComplete="nope"
                  disabled={!stationObject?.location}
                  placeholder="نام منطقه را وارد کنید"
                  className="Area self-stretch pl-24 pr-4 py-2 rounded-3xl input-neo outline-none justify-end items-center gap-2.5 flex"
                  onChange={(e) =>
                    setStationObject({
                      ...stationObject,
                      zone: e?.target?.value,
                    })
                  }
                  defaultValue={stationObject?.zone}
                />
              </Form.Item>
            </div>
          </div>

          <div className="flex flex-row max-lg:items-center justify-center gap-12 max-lg:gap-2 pt-1">
            <Button
              htmlType="submit"
              className="Submitpayment hover:brightness-110 px-8 lg:h-[44px] button-green !border-slate-200 justify-center items-center gap-1 flex"
              onClick={submitStation}
              loading={
                createStationMutation?.isLoading ||
                updateStationMutation?.isLoading
              }
            >
              <img
                src={tikwhite}
                alt="tik-icon"
                className="w-[20px] h-[20px]"
              />

              <p className="text-center w-[120px] max-lg:w-[70px] !text-white text-xl max-lg:text-sm font-bold font-body">
                ثبت ایستگاه
              </p>
            </Button>

            <Button
              className="Cancel hover:brightness-110 px-8 lg:h-[44px] button-red !border-slate-200 justify-center items-center gap-1 flex"
              onClick={() =>
                setWeatherStationState({
                  service: Service.Weather,
                  state: WeatherStationStates.AddStationIntro,
                  stationObject: null,
                })
              }
            >
              <img
                src={crossWhite}
                alt="cancel-icon"
                className="w-[20px] h-[20px]"
              />

              <p className=" text-center w-[120px] max-lg:w-[70px] !text-white text-xl max-lg:text-sm font-medium font-body">
                بازگشت
              </p>
            </Button>
          </div>
        </Form>
        <Button
          className="lg:circle-neo bg-[#E9F0F7] flex items-center justify-center text-[#008a44] hover:!text-[#50aa44] font-bold absolute top-24 max-lg:w-20 left-4 z-[999] !rounded-2xl max-lg:left-0 max-lg:!rounded-l-none"
          icon={<QuestionCircleOutlined className="text-base" />}
          onClick={() => setOpen(true)}
        >
          راهنما
        </Button>
        <Tour
          type="primary"
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          steps={weatherStationFormSteps(ref1, ref2)}
        />
      </div>
    </div>
  );
}

export default MapPoint;
